export default __webpack_public_path__ + "assets/models/f37d824dc3afa76c56ad681fd248fb96.glb";